import * as storage from './storage';

/**
 * The installation id: a random UUID persisted in `localStorage`. It survives logout and token
 * rotations and changes only when the site data is cleared or in another browser. It is never a
 * fingerprint of the browser or the push target.
 */
export const STORAGE_KEY = 'INSTALLATION_ID';

const HEX = '0123456789abcdef';

/** RFC 4122 v4. `crypto` when the browser has it; Math.random otherwise: an opaque id, not a secret. */
export const generateInstallationId = (random = Math.random) => {
  try {
    if (random === Math.random && window.crypto?.randomUUID) {
      return window.crypto.randomUUID();
    }
  } catch {
    /* falls through to the generator */
  }

  let out = '';
  for (let i = 0; i < 36; i += 1) {
    if (i === 8 || i === 13 || i === 18 || i === 23) {
      out += '-';
    } else if (i === 14) {
      out += '4';
    } else if (i === 19) {
      out += HEX[8 + Math.floor(random() * 4)];
    } else {
      out += HEX[Math.floor(random() * 16)];
    }
  }
  return out;
};

const PATTERN = /^[A-Za-z0-9._:-]{8,128}$/;

let cached = null;

export const getInstallationId = async () => {
  if (cached) {
    return cached;
  }

  const stored = storage.read(STORAGE_KEY);
  if (stored && PATTERN.test(stored)) {
    cached = stored;
    return cached;
  }

  cached = generateInstallationId();
  storage.write(STORAGE_KEY, cached);

  return cached;
};

/** Tests and a "clear data" debug action. */
export const resetInstallationId = async () => {
  cached = null;
  storage.remove(STORAGE_KEY);
};
